
import React from "react";
import { CardContent, CardFooter } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";

const PasswordResetSuccess = () => {
  const navigate = useNavigate();

  const handleBackToLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate("/auth?mode=login", { replace: true });
  };

  return (
    <div className="flex flex-col">
      <CardContent className="space-y-4 pt-4 pb-4">
        <div className="bg-green-500/10 border border-green-500/20 rounded-md p-4 text-sm text-green-500 flex items-start gap-2">
          <AlertCircle className="h-5 w-5 flex-shrink-0 pt-0.5" />
          <div>
            <p>Your password has been updated! Please login with your new password.</p>
          </div>
        </div>
      </CardContent>
      
      <CardFooter className="flex flex-col gap-4 pt-4 pb-8">
        <div className="flex justify-center mt-2">
          <button
            onClick={handleBackToLogin}
            className="text-mono-seasalt hover:text-mono-platinum transition-colors text-sm"
          >
            Back to login
          </button>
        </div>
      </CardFooter>
    </div>
  );
};

export default PasswordResetSuccess;
